const introFrench = () => ({
  title: {
    part1: 'Salut.',
    part2: 'Je suis Camile',
  },
  presentation: 'Je suis un développeur de logiciels',
  description:
      "Je peux vous aider à créer un produit, une fonctionnalité ou un site web. Parcourez certains de mes travaux et expériences! Si vous aimez ce que vous voyez et que vous avez un projet à coder, n'hésitez pas à me contacter.",
  resume: 'Obtenez mon CV',
  connect: 'Prenez contact',
  links: {
    link1: 'Services',
    link2: 'Projets récents',
    link3: 'Bibliothèques',
    link4: 'À propos de moi',
    link5: 'Contact',
  },
});

export default introFrench;
